import { Bell, LogOut, Menu } from 'lucide-react';
import ThemeToggle from './ThemeToggle';

type Props = {
  onLogout: () => void;
  title: string;
  subtitle?: string;
  onOpenMobileNav?: () => void;
};

export default function Navbar({ onLogout, title, subtitle, onOpenMobileNav }: Props) {
  return (
    <header className="sticky top-0 z-20 border-b border-gray-200 bg-white/90 px-4 py-3 backdrop-blur sm:px-6 sm:py-4 dark:border-darkCard dark:bg-[#101a23]/90">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <button
            type="button"
            className="chip mb-2 inline-flex lg:hidden"
            onClick={onOpenMobileNav}
            aria-label="Open navigation"
          >
            <Menu className="h-4 w-4" />
            Menu
          </button>
          <p className="text-xs uppercase tracking-[0.12em] text-mutedGray dark:text-darkTextSecondary">Pickaxe Admin Console</p>
          <h1 className="truncate text-lg font-semibold text-darkText sm:text-xl dark:text-darkTextPrimary">{title}</h1>
          {subtitle && <p className="line-clamp-2 text-sm text-mutedGray dark:text-darkTextSecondary">{subtitle}</p>}
        </div>

        <div className="flex flex-wrap items-center justify-end gap-2">
          <button className="chip hidden sm:inline-flex" aria-label="Notifications">
            <Bell className="h-4 w-4" />
          </button>
          <ThemeToggle />
          <button onClick={onLogout} className="btn gap-2 px-3 py-2 sm:px-4 sm:py-3" type="button">
            <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
}
